import { startCase } from 'lodash';
import { useFilterSearchParamWithFF } from 'common/hooks/useFilterSearchParam';
import { AUTHORIZATION_STATUSES_TEXT, AUTHORIZATION_STATUSES, OPEN_AUTHORIZATION_PAGE_STATUSES } from 'common/Status/authorizationConstants';
import useContractedProgramOptions from './useContractedProgramOptions';
import useAssignedToOptions from './useAssignedToOptions';

const DRAWER_FF = 'pays-7500-auth-workqueue-filter-drawer';

const useServiceAuthorizationFilters = ({ authorizationStatus }) => {
  const [requestId, setRequestId] = useFilterSearchParamWithFF('request_id', undefined, DRAWER_FF);
  const [clientName, setClientName] = useFilterSearchParamWithFF('client_name', undefined, DRAWER_FF);
  const [statusValue, setStatus] = useFilterSearchParamWithFF('status', undefined, DRAWER_FF);
  const [contractedPrograms, setContractedPrograms] = useFilterSearchParamWithFF(
    'contracted_programs',
    undefined,
    DRAWER_FF,
  );
  const [primaryHealthInsuranceMemberId, setPrimaryHealthInsuranceMemberId] = useFilterSearchParamWithFF(
    'primary_health_insurance_member_id',
    undefined,
    DRAWER_FF,
  );
  const [assignedTo, setAssignedTo] = useFilterSearchParamWithFF('assigned_to', undefined, DRAWER_FF);

  let statusOptions = [
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.open),
      value: AUTHORIZATION_STATUSES.open,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.inReview),
      value: AUTHORIZATION_STATUSES.inReview,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.accepted),
      value: AUTHORIZATION_STATUSES.accepted,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.autoAccepted),
      value: AUTHORIZATION_STATUSES.autoAccepted,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.rejected),
      value: AUTHORIZATION_STATUSES.rejected,
    },
  ];

  if (authorizationStatus === OPEN_AUTHORIZATION_PAGE_STATUSES) {
    statusOptions = statusOptions.filter((option) => option.value === AUTHORIZATION_STATUSES.open ||
      option.value === AUTHORIZATION_STATUSES.inReview);
  } else if (authorizationStatus === AUTHORIZATION_STATUSES.accepted) {
    statusOptions = statusOptions.filter((option) => option.value === AUTHORIZATION_STATUSES.accepted ||
      option.value === AUTHORIZATION_STATUSES.autoAccepted);
  }

  const assignedToOptions = useAssignedToOptions();
  const contractedProgramOptions = useContractedProgramOptions();

  const resetFilters = () => {
    setRequestId(undefined);
    setClientName(undefined);
    setStatus(undefined);
    setContractedPrograms(undefined);
    setPrimaryHealthInsuranceMemberId(undefined);
    setAssignedTo(undefined);
  };

  const isFiltered = !!requestId ||
    !!clientName ||
    !!statusValue ||
    !!contractedPrograms ||
    !!primaryHealthInsuranceMemberId ||
    !!assignedTo;

  return ({
    filterValues: {
      requestId,
      clientName,
      status: statusValue,
      contractedPrograms,
      primaryHealthInsuranceMemberId,
      assignedTo,
    },
    filterOptions: {
      contractedProgram: contractedProgramOptions,
      status: statusOptions,
      assignedTo: assignedToOptions,
    },
    resetFilters,
    isFiltered,
    setRequestIdFilter: setRequestId,
    setClientNameFilter: setClientName,
    setStatusFilter: setStatus,
    setContractedProgramFilter: setContractedPrograms,
    setPrimaryHealthInsuranceMemberIdFilter: setPrimaryHealthInsuranceMemberId,
    setAssignedToFilter: setAssignedTo,
  });
};

export default useServiceAuthorizationFilters;
